import { createContext, useContext } from 'react';

import { Decorator } from '@storybook/react-vite';

import { SPLIT_TESTS } from '../AnonymousSplitTest/SPLIT_TESTS';

const StorybookSplitTestContext = createContext<string[]>([]);

export const SPLIT_TEST_DECORATOR_IDENTIFIER = 'Split-Test';

export function useStorybookSplitTestControls() {
  const context = useContext(StorybookSplitTestContext);
  // @ts-expect-error We set this in `.stroybook/preview.ts`
  if (!window.IS_STORYBOOK) {
    return [];
  }

  if (!context) {
    console.error('Make sure to wrap the `splitTest` decorator');
    return [];
  }

  return SPLIT_TESTS.tests.map((test) => {
    return {
      test_name: test.name,
      branch_name: context.includes(test.name) ? 'INCLUDE' : 'EXCLUDE',
    };
  });
}

export const splitTest: Decorator = (Story, context) => {
  const splitTests = (context.args[SPLIT_TEST_DECORATOR_IDENTIFIER] ||
    []) as string[];

  return (
    <StorybookSplitTestContext.Provider value={splitTests}>
      <Story />
    </StorybookSplitTestContext.Provider>
  );
};
